import { geocoderFactory } from "common/utils/Geocoder";
import { CarEBoxLocation } from "../types";
import { useBoolState } from "common/hooks";
import { useCallback, useMemo, useState } from "react";
import { MAP_NAMES } from "common/constants";

export const useReverseGeocode = () => {
  const [isLoading, toggleLoading] = useBoolState(false);
  const [address, setAddress] = useState<Nullable<string>>(null);
  const geocoder = useMemo(() => geocoderFactory(MAP_NAMES.here), []);

  const reverseGeocode = useCallback(
    async (
      carEBoxLocation: Pick<CarEBoxLocation, "longitude" | "latitude">
    ) => {
      toggleLoading();
      try {
        const data = await geocoder.geocodeCoords({
          lat: carEBoxLocation.latitude,
          lng: carEBoxLocation.longitude,
        });
        setAddress(data.address);
      } catch (error) {
        setAddress("error");
      } finally {
        toggleLoading();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    reverseGeocode,
    isLoading,
    address,
  };
};
